import React from 'react';
import {IndexRedirect, IndexRoute, Route} from 'react-router';
import CallsLayout from '$pages/$calls/@common/calls-layout';
import SelfCallsComponent from '$pages/$calls/$self/SelfCallsComponent';
import Calls from '$pages/$calls/Calls';
import {InternalShareRedirect} from 'components/pure/sharing/InternalShareRedirect';
import CallsListComponent from '@components/calls-list/CallsListComponent';

export const callsRoute = (
  <Route path="calls" component={Calls}>
    <IndexRedirect to="my" />
    <Route path="my(/:savedSearchId)" component={CallsLayout}>
      <IndexRoute component={props => <CallsListComponent {...props}></CallsListComponent>} />
    </Route>
    <Route path="sharedWithMe/:permalink" component={InternalShareRedirect} />
    <Route path="self" component={SelfCallsComponent} />
  </Route>
);
